import React from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Login from "./components/auth/Login";
import Home from "./components/home/Home";
import VisitDetails from "./components/home/visits/VisitDetails";
import NavBar from "./components/misc/NavBar";
import VisitHodTpoDetails from "./components/home/visits/details/VisitHodTpoDetails";
import HODEdit from "./components/home/visits/details/HODEdit";
import AddHOD from "./components/home/visits/details/AddHOD";
import AddTPO from "./components/home/visits/details/AddTPO";
import BackButton from "./components/misc/BackButton";
import AddVisit from "./components/home/visits/AddVisit";
import ChangePassword from "./components/auth/ChangePassword";
import CollegeSearch from "./components/home/CollegeSearch";
import CollegeHodTpoDetails from "./components/home/CollegeHodTpoDetails";
import CreatePDF from "./components/home/pdf/CreatePDF";
import GeneratePDF from "./components/home/pdf/GeneratePDF";
import MapStudents from "./components/home/pdf/MapStudents";
import PlacementFeedback from "./components/home/placements/PlacementFeedback";
import FrontOfficeFeedback from "./components/home/frontoffice/FrontOfficeFeedback";
import StudentDownload from "./components/home/StudentDownload";
import Chat from "./components/home/whatsapp/Chat";
import ReplyChat from "./components/home/whatsapp/ReplyChat";

// Routes that should not show NavBar
const noNavBarRoutes = [
  '/whatsapp/chat',
  '/whatsapp/reply-chat',
  '/placements',
  '/frontoffice'
];

const AppContent = () => {
  const location = useLocation();
  const shouldShowNavBar = !noNavBarRoutes.includes(location.pathname);

  return (
    <>
      {shouldShowNavBar && (
        <NavBar
          title="College Visits"
          leftButton={<BackButton />}
          rightButton={<button onClick={() => alert('More clicked')}>More</button>}
        />
      )}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/visits" element={<VisitDetails />} />
        <Route path="/visits/add" element={<AddVisit />} />
        <Route path="/visits/details" element={<VisitHodTpoDetails />} />
        <Route path="/visits/details/edit" element={<HODEdit />} />
        <Route path="/visits/details/addhod" element={<AddHOD />} />
        <Route path="/visits/details/addtpo" element={<AddTPO />} />
        <Route path="/search" element={<CollegeSearch />} />
        <Route path="/college" element={<CollegeHodTpoDetails />} />
        <Route path="/createpdf" element={<CreatePDF />} />
        <Route path="/generatepdf" element={<GeneratePDF />} />
        <Route path="/mapstudents" element={<MapStudents />} />
        <Route path="/student-download" element={<StudentDownload />} />
        <Route path="/placements" element={<PlacementFeedback />} />
        <Route path="/frontoffice" element={<FrontOfficeFeedback />} />
        <Route path="/whatsapp/chat" element={<Chat />} />
        <Route path="/whatsapp/reply-chat" element={<ReplyChat />} />
      </Routes>
    </>
  );
};

function Router() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default Router;
